import { TextField } from "@material-ui/core";
import { Autocomplete } from "@material-ui/lab";
import React from "react";
import { HealthDeparmentNumberLookup } from "../../constants/AccountingNumbers";
import { User } from "../../graphql/baseTypes";
import { FilterProps } from "./types";

interface Props extends FilterProps<User> {
  value?: string | null;
}

const HealtDeparmentNumberFilter: React.FC<Props> = ({
  onChange,
  onClear,
  value,
}) => {
  return (
    <Autocomplete
      id="healtdeparmentnumber-filter-autocomplete"
      options={Object.keys(HealthDeparmentNumberLookup)}
      value={value}
      getOptionLabel={(option) => HealthDeparmentNumberLookup[option]}
      onChange={(_, selection) => {
        if (selection) {
          onChange(selection);
        } else {
          onClear();
        }
      }}
      getOptionSelected={(option, value) =>
        value && value ? option === value : false
      }
      style={{ width: 200 }}
      renderInput={(params) => (
        <TextField
          {...params}
          label="Abrechnungsnummer"
          variant="outlined"
          size={"small"}
        />
      )}
    />
  );
};

export default HealtDeparmentNumberFilter;
